import Vue from 'vue'
import VueRouter from 'vue-router'
import {store} from './store/store'
import VueResource from 'vue-resource'
import VueAnalytics from 'vue-analytics'
import VueScrollTo from 'vue-scrollto'
import Vue2Filters from 'vue2-filters'
import VueWaypoint from 'vue-waypoint'
import * as VueGoogleMaps from 'vue2-google-maps'
import SocialSharing from 'vue-social-sharing'
import './assets/scss/app.scss'
import { routes } from './routes'

// window.axios = require('axios');
// window.axios.defaults.headers.common = {
//   'Accept': 'application/json',
//   'Content-Type': 'application/json'
// };

Vue.use(VueRouter)
Vue.use(VueResource)
Vue.use(Vue2Filters)
Vue.use(VueWaypoint)
Vue.use(SocialSharing)
Vue.use(VueScrollTo, {
  container: "body",
  duration: 500,
  easing: "ease",
  offset: 0,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
})

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyD0GSeDjUlxHVcDA02s-2w2rN3aU5vx3-U',
    libraries: 'places', // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)
  }
})

Vue.http.options.emulateJSON = true;
Vue.http.options.emulateHTTP = true;

import App from './App'

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
       return savedPosition
     } else {
       const position = {}
       position.x = 0
       position.y = 0
     }
  }
})

new Vue({
  el: '#app',
  store:store,
  template: '<App />',
  components: { App },
  router
});

Vue.use(VueAnalytics, {
  id: 'UA-120141183-1',
  router
});

router.beforeEach(function (to, from, next) { 
  TweenMax.to(window, 0, {scrollTo:{y:0, x:0}});
  next();
});


// WEBPACK FOOTER //
// ./src/main.js